;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();const STORAGE_KEY_PREFIX = "premium-upgrade-request:v1";

type PremiumUpgradeRequestStorageValue = {
	cooldownUntil: string;
};

interface StorageLike {
	getItem: (key: string) => string | null;
	setItem: (key: string, value: string) => void;
}

interface WindowLike {
	localStorage?: StorageLike;
}

export function getPremiumUpgradeRequestStorageKey(
	organizationId: string,
): string {
	return `${STORAGE_KEY_PREFIX}:${organizationId}`;
}

function getStorage(windowObject?: WindowLike): StorageLike | null {
	if (windowObject?.localStorage) {
		return windowObject.localStorage;
	}
	if (typeof window === "undefined" || !window.localStorage) {
		return null;
	}
	return window.localStorage;
}

export function readPremiumUpgradeRequestCooldown({
	now = Date.now(),
	organizationId,
	windowObject,
}: {
	organizationId: string;
	now?: number;
	windowObject?: WindowLike;
}): PremiumUpgradeRequestStorageValue | null {
	const storage = getStorage(windowObject);
	if (!storage) {
		return null;
	}

	try {
		const raw = storage.getItem(
			getPremiumUpgradeRequestStorageKey(organizationId),
		);
		if (!raw) {
			return null;
		}

		const parsed = JSON.parse(
			raw,
		) as Partial<PremiumUpgradeRequestStorageValue>;
		if (!parsed.cooldownUntil) {
			return null;
		}

		if (new Date(parsed.cooldownUntil).getTime() <= now) {
			return null;
		}

		return { cooldownUntil: parsed.cooldownUntil };
	} catch {
		return null;
	}
}

export function writePremiumUpgradeRequestCooldown({
	cooldownUntil,
	organizationId,
	windowObject,
}: {
	cooldownUntil: string;
	organizationId: string;
	windowObject?: WindowLike;
}): void {
	const storage = getStorage(windowObject);
	if (!storage) {
		return;
	}

	try {
		storage.setItem(
			getPremiumUpgradeRequestStorageKey(organizationId),
			JSON.stringify({
				cooldownUntil,
			} satisfies PremiumUpgradeRequestStorageValue),
		);
	} catch {
		// localStorage may be unavailable (private browsing, quota)
	}
}

export function isPremiumUpgradeRequestCooldownActive({
	now = Date.now(),
	organizationId,
	windowObject,
}: {
	organizationId: string;
	now?: number;
	windowObject?: WindowLike;
}): boolean {
	return (
		readPremiumUpgradeRequestCooldown({
			now,
			organizationId,
			windowObject,
		}) !== null
	);
}
